import styled from '@emotion/styled';

export const CustomCircularIndicatorContainer = styled.div`
  text-align: center;
  .MuiCircularProgress-circleIndeterminate {
    width: 30%;
  }
`;
